module.exports = __webpack_public_path__ + "static/media/faqBalance-en-ru.935bad17.vtt";